import { useEffect, useState } from 'react'
import { Gift, Loader2 } from 'lucide-react'
import { kassaAPI } from '@/lib/api'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

const formatEuro = (cents) => `€${(cents / 100).toFixed(2)}`

export default function KassaVouchersCard() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    kassaAPI.getMyVouchers()
      .then(res => { if (alive) setData(res.data) })
      .catch(() => { if (alive) setFailed(true) })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [])

  if (loading) return null
  if (failed) return null
  if (!data?.linked) return null

  const vouchers = data.vouchers || []

  return (
    <Card className="border-neon-purple/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Gift className="h-5 w-5 text-neon-purple" />
          <span>Cadeaubonnen</span>
        </CardTitle>
        <CardDescription>Beschikbare vouchers op je account</CardDescription>
      </CardHeader>
      <CardContent>
        {vouchers.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-4">Geen actieve vouchers.</p>
        ) : (
          <div className="space-y-2">
            {vouchers.map((v) => (
              <div key={v.id ?? `${v.voucher?.name}-${v.issued_at}`} className="flex items-center justify-between p-2.5 rounded-lg border border-border/50 bg-card/50">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{v.voucher?.name || 'Voucher'}</p>
                  {v.note && <p className="text-[10px] text-muted-foreground truncate">{v.note}</p>}
                  {v.issued_at && (
                    <p className="text-[10px] text-muted-foreground">
                      uitgegeven {new Date(v.issued_at).toLocaleDateString('nl-BE', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </p>
                  )}
                </div>
                {typeof v.voucher?.value_cents === 'number' && (
                  <Badge variant="outline" className="ml-3 text-neon-purple">{formatEuro(v.voucher.value_cents)}</Badge>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
